module.exports = __webpack_public_path__ + "static/media/bathroom-re-fit_03.ff9bbf01.png";